import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { beeldLabel, imgSet, onderwerpLabel, optionLabel } from "../../data/portfolio";
import { quoteHref } from "../../data/homeContent";
import { trackEvent } from "../../lib/api";

export const inspirationHref = (it) => quoteHref(it.onderwerp, { inspiratie: it.ref });
export const inspirationChips = (it) => [onderwerpLabel(it.onderwerp), optionLabel("color", it.color), optionLabel("style", it.style), optionLabel("uitvoering", it.uitvoering)].filter(Boolean);

export const InspirationBadge = ({ it, className = "" }) => (
  <span className={`rounded-md bg-white/90 px-2 py-0.5 text-[11px] font-medium text-slate-700 backdrop-blur-sm ${className}`} data-testid="inspiration-badge">{beeldLabel(it)}</span>
);

export const InspirationCard = ({ it, onOpen }) => (
  <li className="mb-6 break-inside-avoid" data-testid="inspiration-card">
    <article className="card card-hover group overflow-hidden">
      <button type="button" onClick={() => onOpen(it)} className="relative block w-full overflow-hidden bg-slate-100 text-left" aria-label={`${it.title} groter bekijken`} data-testid={`inspiration-open-${it.ref}`}>
        <img src={it.image.path} srcSet={imgSet(it.image.path)} sizes="(min-width: 1024px) 400px, (min-width: 640px) 50vw, calc(100vw - 32px)" alt={it.image.alt || it.title}
          loading="lazy" decoding="async" className="w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
        <InspirationBadge it={it} className="absolute left-3 top-3" />
      </button>
      <div className="p-5">
        <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-gold">{onderwerpLabel(it.onderwerp)}</p>
        <h3 className="mt-1.5 text-[17px] font-semibold leading-snug text-ink">{it.title}</h3>
        {it.caption && <p className="mt-1.5 text-[14.5px] leading-relaxed text-slate-600">{it.caption}</p>}
        <ul className="mt-3 flex flex-wrap gap-1.5">
          {inspirationChips(it).slice(1).map((c) => <li key={c} className="rounded-full bg-slate-100 px-2.5 py-1 text-[12px] font-medium text-slate-600">{c}</li>)}
        </ul>
        <Link to={inspirationHref(it)} onClick={() => trackEvent("cta_inspiration_click", { ref: it.ref })} data-testid={`inspiration-request-${it.ref}`}
          className="mt-4 inline-flex items-center gap-1.5 text-[14.5px] font-semibold text-maas hover:text-maas-hover">
          Deze uitvoering aanvragen <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
        </Link>
      </div>
    </article>
  </li>
);
